export function isArr(obj) {
    return Array.isArray(obj)
}